import { modalType } from '../../util/ModalUtil';
import { useState, useRef } from 'react';
import CodeUtil from '../../util/CodeUtil';
import { CODE_GROUP_ID } from '../../constant/Constant';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import PopupRef from '../../component/PopupRef';
import InputBox from '../../component/InputBox';
import SelectionBox from '../../component/SelectionBox';
import TelNoInputBox from '../../component/TelNoInputBox';
import { ToggleButtonUserRegValidStatus, ToggleButtonEnrolmentValidStatus } from '../../component/ToggleBottonBox';
import TextAreaBox from '../../component/TextAreaBox';
import { useDispatch } from 'react-redux';
import NullCheckUtil from '../../util/NullCheckUtil';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';

/* 모달을 닫기 위해서 modalRef를 반드시 전달받아야 함 */
const EnrolmentStatusStudentModal = ({ module, type, row, modalRef, isUserUniversityCheck = true, callback }) => {
    const dispatch = useDispatch();

    const [userRegValidStatusCd, setUserRegValidStatusCd] = useState(row && row.userRegValidStatusCd);
    const [enrolmentValidStatusCd, setEnrolmentValidStatusCd] = useState(row && row.enrolmentValidStatusCd);
    const [lessonUniversityStudentId, setLessonUniversityStudentId] = useState(row && row.lessonUniversityStudentId);
    const [lessonUniversityNoticeMsg, setLessonUniversityNoticeMsg] = useState(row && row.lessonUniversityNoticeMsg);
    const [preLessonYn, setPreLessonYn] = useState(row && row.preLessonYn);
    const [preLessonUniversityStudentId, setPreLessonUniversityStudentId] = useState(
        row && row.preLessonUniversityStudentId,
    );

    const isEditUserUniversity = type == modalType.EDIT && isUserUniversityCheck;
    const isEditLessonUniversity = type == modalType.EDIT && !isUserUniversityCheck;

    const popupRef = useRef(null);

    // 취소 버튼
    const handleCancel = () => {
        modalRef.current.close();
    };

    // 확인 버튼
    const handleConfirm = () => {
        if (type == modalType.EDIT) {
            if (NullCheckUtil.isEmpty(userRegValidStatusCd)) {
                popupRef.current.openInfo('본교가입검증상태 값을 선택해 주세요.');
            } else if (NullCheckUtil.isEmpty(enrolmentValidStatusCd)) {
                popupRef.current.openInfo('본교수강자격검증 값을 선택해 주세요.');
            } else {
                dispatch(
                    module({
                        data: {
                            semesterId: row.semesterId,
                            userId: row.userId,
                            lessonUniversityCd: row.lessonUniversityCd,
                            userRegValidStatusCd,
                            enrolmentValidStatusCd,
                            lessonUniversityStudentId,
                            lessonUniversityNoticeMsg,
                            force: true,
                        },
                        callback: () => {
                            popupRef.current.openInfo('정상 처리 되었습니다.', () => {
                                return function () {
                                    callback();
                                    modalRef.current.close();
                                };
                            });
                        },
                    }),
                );
            }
        } else {
            modalRef.current.close();
        }
    };

    return (
        <>
            <ModalHeader
                title={type == modalType.EDIT ? '수강신청 학생정보 수정' : '수강신청 학생정보 조회'}
                modalRef={modalRef}
            />
            <div className='modal-body'>
                <div
                    className={
                        'con-inner  ' +
                        (isEditUserUniversity ? 'EnrolmentStatusStudentModal4UserUniv' : 'EnrolmentStatusStudentModal')
                    }
                >
                    <InfoTxt
                        infoTxt={
                            isEditUserUniversity
                                ? '수강신청 학생의 수강 자격 정보를 수정합니다.'
                                : '수강신청 학생의 수강등록을 위한 교류학생정보를 수정합니다.'
                        }
                    />
                    <div>
                        <div className='form-box-row'>
                            <InputBox title='소속대학' value={row && row.userUniversityNm} disabled />
                            <InputBox title='전공(학과)' value={row && row.majorDeptNm} disabled />
                            <InputBox title='학번' value={row && row.studentId} disabled />
                        </div>
                        <div className='form-box-row'>
                            <InputBox title='이름' value={row && row.userNm} disabled />

                            <InputBox title='사용자ID' value={row && row.userId} disabled />
                            <TelNoInputBox title='연락처' value={row && row.telNo} disabled />
                        </div>
                        <div className='form-box-row'>
                            <SelectionBox
                                title='본교가입검증'
                                disabled={!isEditUserUniversity}
                                value={userRegValidStatusCd}
                                useAll={false}
                                options={CodeUtil.getCodes(CODE_GROUP_ID.USER_REG_VALID_STATUS)}
                                onChange={(e) => setUserRegValidStatusCd(e.target.value)}
                            />
                            <SelectionBox
                                title='본교수강자격검증'
                                disabled={!isEditUserUniversity}
                                value={enrolmentValidStatusCd}
                                useAll={false}
                                options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_VALID_STATUS)}
                                onChange={(e) => setEnrolmentValidStatusCd(e.target.value)}
                            />
                        </div>
                        {/* // 개설대학인 경우에만 해당정보 표시 */}
                        {isEditLessonUniversity && (
                            <>
                                <div className='form-box-row'>
                                    <InputBox
                                        title='과거 수강여부'
                                        disabled={isEditLessonUniversity}
                                        value={preLessonYn}
                                        onChange={(e) => setPreLessonYn(e.target.value)}
                                    />
                                    <InputBox
                                        title='과거 개설대학학번'
                                        disabled={isEditLessonUniversity}
                                        value={preLessonUniversityStudentId}
                                        onChange={(e) => setPreLessonUniversityStudentId(e.target.value)}
                                    />
                                </div>
                                <div className='form-box-row'>
                                    <InputBox
                                        title='개설대학학번'
                                        disabled={!isEditLessonUniversity}
                                        value={lessonUniversityStudentId}
                                        onChange={(e) => setLessonUniversityStudentId(e.target.value)}
                                    />
                                </div>
                                <div className='form-box-row'>
                                    <TextAreaBox
                                        title='개설대학안내메시지'
                                        disabled={!isEditLessonUniversity}
                                        value={lessonUniversityNoticeMsg}
                                        placeholder='안내 메시지를 입력하세요.'
                                        onChange={(e) => setLessonUniversityNoticeMsg(e.target.value)}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    {type == modalType.EDIT && <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />}
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default EnrolmentStatusStudentModal;
